import { connect } from "react-redux";
import ComparedRow from "./ComparedRow";
import { handleChangeTrendBaseline } from "../../../../../../../../../../../../redux/actions";

// Only this leader's override and the match mode — plain strings. A pick on
// another row leaves both unchanged, so connect skips re-rendering this row.
// Overrides are keyed by the leader's current 360 (`leader.value`), the same
// project id the pairing is sent back under, not by the row's email.
const mapStateToProps = (state, ownProps) => ({
    pickedValue: state.BenchmarkFilteringReducer.trendPairing.baselineOverrides[ownProps.leader.value],
    matchMode: state.BenchmarkFilteringReducer.trendPairing.matchMode,
});

// projectId: the leader's current 360; value: the earlier one picked as its baseline.
const mapDispatchToProps = (dispatch) => ({
    onChangeBaseline: (projectId, value) => dispatch(handleChangeTrendBaseline({ projectId, value })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ComparedRow);
